import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap"
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import useForm from "../../lib/useForm"
import Loading from 'lib/loading'

const FormConfiguracao = ({filial}) => {
  //valores iniciais do formulario
  const inicialForm = {
    filial_id           : "",
    razao_social        : "",
    fantasia            : "",
    cnpj                : "",
    inscricao           : "",
    insc_municipal      : "",

    cep                 : "",
    endereco            : "",
    numero              : "",
    bairro              : "",
    cidade              : "",
    estado              : "",

    dadosContador : 
    {
      nome          : "",
      cnpj          : "",
      cpf           : "",
      crc           : "",
      telefone      : "",
      email         : "",
      endereco      : "",
      numero        : "",
      bairro        : "",
      cep           : "",
      cod_municipio : ""
    }
  }

  const [form, onChange, setForm] = useForm(inicialForm)
  const [loading, setLoading]     = useState(true)
  const [activeTab, setActiveTab] = useState('1')

  const editConfig = () => {
    setLoading(true)
    let lista = []
    try{
      const retorno = rest.get(rotas.configLojas+'/'+filial.value)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success === 'S' && ret.lista !== ''){
          setForm(ret.lista[0])
          setLoading(false)
        }
      })
      return (lista)
    }catch(err){

    }
  }

  useEffect(() => {
    setLoading(true)
    if(filial != null){
      // console.log(filial)
      editConfig()
    }else{
      setForm(inicialForm)
    }
    setLoading(false)
  },[filial]) // eslint-disable-line react-hooks/exhaustive-deps

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()
    // console.log(form)
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    if (filial === null){
      return (<></>)
    }else{
      return (
        <>
        <FormGroup className="formCadastro m-0 p-4">
          <Nav pills className="nav-pills-default justify-content-center mb-4">
            <NavItem>
              <NavLink
                className = {activeTab === '1' ? 'active' : ''}
                onClick   = {() => setActiveTab('1')}
              >
                Loja
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab === '2' ? 'active' : ''}
                onClick   = {() => setActiveTab('2')}
              >
                Dados do contador
              </NavLink>
            </NavItem>
          </Nav>

          <hr />

          <Form onSubmit={handleSubmit}>
            {/* DADOS DAS LOJAS */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">

                <Col md='12' className="mt-4 p-0">
                  <div className="card-2">
                    <span className="tag-card-div" style={{top: '-7px'}}>Dados da loja</span>
                    <Row className="mt-2">
                      <Col md='6'>
                        <FormGroup>
                          <Label for="razao">Razão Social</Label>
                          <Input
                            disabled
                            required
                            name      = "razao"
                            id        = "razao"
                            value     = {form.razao_social}
                            onChange  = {onChange('razao_social')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='6'>
                        <FormGroup>
                          <Label for="fantasia">Fantasia</Label>
                          <Input
                            disabled
                            name      = "fantasia"
                            id        = "fantasia"
                            value     = {form.fantasia}
                            onChange  = {onChange('fantasia')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md='4'>
                        <FormGroup>
                          <Label for="cnpj">CNPJ</Label>
                          <Input
                            disabled
                            required
                            name      = "cnpj"
                            id        = "cnpj"
                            value     = {form.cnpj}
                            onChange  = {onChange('cnpj')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <Label for="estadual">Inscrição Estadual</Label>
                          <Input
                            disabled
                            name      = "estadual"
                            id        = "estadual"
                            value     = {form.inscricao}
                            onChange  = {onChange('inscricao')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <Label for="municipal">Inscrição Municipal</Label>
                          <Input
                            disabled
                            name      = "municipal"
                            id        = "municipal"
                            value     = {form.insc_municipal}
                            onChange  = {onChange('insc_municipal')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col md='12' className="mt-4 p-0">
                  <div className="card-2">
                    <span className="tag-card-div" style={{top: '-7px'}}>Endereço</span>
                    <Row className="mt-2">
                      <Col md='4'>
                        <FormGroup>
                          <Label for="cep">CEP</Label>
                          <Input
                            disabled
                            required
                            name      = "cep"
                            id        = "cep"
                            value     = {form.cep}
                            onChange  = {onChange('cep')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='6'>
                        <FormGroup>
                          <Label for="endereco">Endereço</Label>
                          <Input
                            disabled
                            name      = "endereco"
                            id        = "endereco"
                            value     = {form.endereco}
                            onChange  = {onChange('endereco')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='2'>
                        <FormGroup>
                          <Label for="numero">Número</Label>
                          <Input
                            disabled
                            name      = "numero"
                            id        = "numero"
                            value     = {form.numero}
                            onChange  = {onChange('numero')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md='4'>
                        <FormGroup>
                          <Label for="bairro">Bairro</Label>
                          <Input
                            disabled
                            required
                            name      = "bairro"
                            id        = "bairro"
                            value     = {form.bairro}
                            onChange  = {onChange('bairro')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='7'>
                        <FormGroup>
                          <Label for="cidade">Cidade</Label>
                          <Input
                            disabled
                            name      = "cidade"
                            id        = "cidade"
                            value     = {form.cidade}
                            onChange  = {onChange('cidade')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='1'>
                        <FormGroup>
                          <Label for="estado">Estado</Label>
                          <Input
                            disabled
                            name      = "estado"
                            id        = "estado"
                            value     = {form.estado}
                            onChange  = {onChange('estado')}
                          />
                        </FormGroup>
                      </Col>

                    </Row>
                  </div>
                </Col>

              </TabPane>
            </TabContent>

            {/* DADOS DO CONTADOR */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="2">

                <Col md='12' className="mt-4 p-0">
                  <div className="card-2">
                    <span className="tag-card-div" style={{top: '-7px'}}>Dados do contador</span>
                    <Row className="mt-2">
                      <Col md='12'>
                        <FormGroup>
                          <Label for="nomeCont">Contador ou Contabilidade</Label>
                          <Input
                            disabled
                            required
                            name      = "nomeCont"
                            id        = "nomeCont"
                            value     = {form.dadosContador ? form.dadosContador.nome : ''}
                            onChange  = {onChange('dadosContador.nome')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md='4'>
                        <FormGroup>
                          <Label for="cnpjCont">CNPJ</Label>
                          <Input
                            disabled
                            required
                            name      = "cnpjCont"
                            id        = "cnpjCont"
                            value     = {form.dadosContador ? form.dadosContador.cnpj: ''}
                            onChange  = {onChange('dadosContador.cnpj')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <Label for="cpfCont">CPF</Label>
                          <Input
                            disabled
                            name      = "cpfCont"
                            id        = "cpfCont"
                            value     = {form.dadosContador ? form.dadosContador.cpf : ''}
                            onChange  = {onChange('dadosContador.cpf')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <Label for="crcCont">C.R.C</Label>
                          <Input
                            disabled
                            name      = "crcCont"
                            id        = "crcCont"
                            value     = {form.dadosContador ? form.dadosContador.crc : ''}
                            onChange  = {onChange('dadosContador.crc')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md='4'>
                        <FormGroup>
                          <Label for="telefoneCont">Telefone</Label>
                          <Input
                            disabled
                            required
                            name      = "telefoneCont"
                            id        = "telefoneCont"
                            value     = {form.dadosContador ? form.dadosContador.telefone : ''}
                            onChange  = {onChange('dadosContador.telefone')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='8'>
                        <FormGroup>
                          <Label for="emailCont">Email</Label>
                          <Input
                            disabled
                            name      = "emailCont"
                            id        = "emailCont"
                            value     = {form.dadosContador ? form.dadosContador.email : ''}
                            onChange  = {onChange('dadosContador.email')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col md='12' className="mt-4 p-0">
                  <div className="card-2">
                    <span className="tag-card-div" style={{top: '-7px'}}>Endereço</span>
                    <Row className="mt-2">
                      <Col md='10'>
                        <FormGroup>
                          <Label for="enderecoCont">Endereço</Label>
                          <Input
                            disabled
                            name      = "enderecoCont"
                            id        = "enderecoCont"
                            value     = {form.dadosContador ? form.dadosContador.endereco : ''}
                            onChange  = {onChange('dadosContador.endereco')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='2'>
                        <FormGroup>
                          <Label for="numeroCont">Número</Label>
                          <Input
                            disabled
                            name      = "numeroCont"
                            id        = "numeroCont"
                            value     = {form.dadosContador ? form.dadosContador.numero : ''}
                            onChange  = {onChange('dadosContador.numero')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md='6'>
                        <FormGroup>
                          <Label for="bairroCont">Bairro</Label>
                          <Input
                            disabled
                            required
                            name      = "bairroCont"
                            id        = "bairroCont"
                            value     = {form.dadosContador ? form.dadosContador.bairro : ''}
                            onChange  = {onChange('dadosContador.bairro')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='3'>
                        <FormGroup>
                          <Label for="cepCont">CEP</Label>
                          <Input
                            disabled
                            name      = "cepCont"
                            id        = "cepCont"
                            value     = {form.dadosContador ? form.dadosContador.cep : ''}
                            onChange  = {onChange('dadosContador.cep')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='3'>
                        <FormGroup>
                          <Label for="municipioCont">Cod. Municipio</Label>
                          <Input
                            disabled
                            name      = "municipioCont"
                            id        = "municipioCont"
                            value     = {form.dadosContador ? form.dadosContador.cod_municipio : ''}
                            onChange  = {onChange('dadosContador.cod_municipio')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </Col>

              </TabPane>
            </TabContent>
            
            {/* <Col className="text-center pt-3 mb-0">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={console.log(form)}>Fechar</Button>
            </Col> */}
          </Form>
        </FormGroup>
        </>
      )
    }
  }

}

export default FormConfiguracao
